import { ActivityLogServices } from './../services/activitylog.services';
import { SelectItem, MessageService } from 'primeng/api';
import { ActivatedRoute, Params } from '@angular/router';
import {
    FormGroup,
    FormBuilder,
    ReactiveFormsModule,
    FormControl
} from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';

@Component({
    templateUrl: 'new-activitylog.component.html',
    standalone: false
})
export class CreateActivityLogComponent implements OnInit {
    activitylogForm: FormGroup;
    Id: number;
    accessLog: any;
    cBusiness: any;
    cUsers: any;
    business: SelectItem[];
    users: SelectItem[];

    constructor(
        private fb: FormBuilder,
        private activityLogServices: ActivityLogServices,
        private activatedRoute: ActivatedRoute,
        private messageService: MessageService,
        private route: ActivatedRoute,
        private location: Location
    ) {
        this.activitylogForm = this.fb.group({
            username: [''],
            business: [''],
            ip: [''],
            browser: [''],
            os: ['']
        });
    }

    showSuccess() {
        this.messageService.add({
            severity: 'success',
            summary: 'Add/Update',
            detail: 'Data saved successfully',
            life: 2000
        });
    }

    ngOnInit() {
        document.querySelector("body").classList.remove("opened");
    }

    gotoList() {
        this.location.back();
    }

    // TODO: to be worked on save funs
    saveChanges() {}
}
